import { styled } from '../../../common/ui'

export const ExtraInfo = styled.div`
  margin: 0 0 25px 0;

  display: flex;
  align-items: baseline;
  align-content: space-between;
  @media all and (max-width: 992px) {
    flex-wrap: wrap;
  }
`
